import { TextPatternScannerUiResult, mapRTUUIResult, withSBErrorHandling, } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotTextPatternImpl = {
    async startScanner(configuration) {
        return withSBErrorHandling(async () => mapRTUUIResult(await ScanbotSDKPlugin.startTextPatternScanner(configuration), TextPatternScannerUiResult));
    },
    async forceCloseScanner() {
        return withSBErrorHandling(ScanbotSDKPlugin.forceCloseTextPatternScanner);
    },
};
//# sourceMappingURL=TextPatternImpl.js.map